import { createTheme, Theme } from '@mui/material'
import React, { createContext, useContext, ReactNode } from 'react';
import '@fontsource/poppins';
import '@mui/x-date-pickers/themeAugmentation';

// Default theme object that matches our CSS variables
export const defaultTheme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    h1: {
      fontFamily: 'Poppins, sans-serif',
    },
    h2: {
      fontFamily: 'Poppins, sans-serif',
    },
    h3: {
      fontFamily: 'Poppins, sans-serif',
    },
    h4: {
      fontFamily: 'Poppins, sans-serif',
    },
    h5: {
      fontFamily: 'Poppins, sans-serif',
    },
    h6: {
      fontFamily: 'Poppins, sans-serif',
    },
    body1: {
      fontFamily: 'Poppins, sans-serif',
    },
    body2: {
      fontFamily: 'Poppins, sans-serif',
    },
    button: {
      fontFamily: 'Poppins, sans-serif',
    },
    caption: {
      fontFamily: 'Poppins, sans-serif',
    },
    overline: {
      fontFamily: 'Poppins, sans-serif',
    },
    subtitle1: {
      fontFamily: 'Poppins, sans-serif',
    },
    subtitle2: {
      fontFamily: 'Poppins, sans-serif',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif !important',
        },
      },
    },
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          zIndex: 2100,
        },
        paper: {
          zIndex: 2100,
        },
      },
    },
    MuiCssBaseline: {
      // styleOverrides: {
      //   '*': {
      //     fontFamily: 'Poppins, sans-serif !important',
      //   },
      //   'html': {
      //     fontFamily: 'Poppins, sans-serif !important',
      //   },
      //   'body': {
      //     fontFamily: 'Poppins, sans-serif !important',
      //   },
      // },
      styleOverrides: `
        @font-face {
          font-family: Poppins;
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Poppins'), local('Poppins-Regular'), url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfedw.woff2) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        `,
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, sans-serif !important',
        },
      },
    },
  },
});

// Create theme context
const ThemeContext = createContext<Theme | undefined>(undefined);

// Theme provider props
interface ThemeProviderProps {
  children: ReactNode;
  theme: Theme;
}

// Theme provider component
export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  theme = defaultTheme,
}) => {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};

// Custom hook to use theme
export const useTheme = (): Theme => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Helper function to get CSS variable value
export const getCSSVariable = (variableName: string): string => {
  return `var(--${variableName})`;
};
